(function () {
  var OPEN = 'is-open';

  function panelFor(name) {
    return document.querySelector('[data-drawer="' + name + '"]');
  }

  function open(drawer) {
    if (!drawer) return;
    drawer.hidden = false;
    // Force a synchronous reflow so the transition has a starting point. Done
    // with rAF this could silently never run in a throttled/unpainted tab,
    // leaving the panel off-screen with the page scroll already locked.
    void drawer.offsetWidth;
    drawer.classList.add(OPEN);
    document.body.style.overflow = 'hidden';
  }

  function close(drawer) {
    if (!drawer) return;
    drawer.classList.remove(OPEN);
    document.body.style.overflow = '';

    var panel = drawer.querySelector('.drawer__panel');
    if (!panel || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      drawer.hidden = true;
      return;
    }

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      drawer.hidden = true;
    };

    panel.addEventListener('transitionend', finish, { once: true });
    // Never leave the scrim stuck over the page if the transition never fires.
    window.setTimeout(finish, 600);
  }

  function closeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer]'), close);
  }

  /*
   * Re-render the cart drawer and the header count from the server.
   *
   * The drawer is a Liquid snippet in the layout rather than a section, so
   * there is no section-rendering endpoint for it. Re-fetching the current
   * path and lifting the two fragments out keeps one source of truth for the
   * cart markup instead of rebuilding the lines in JavaScript.
   */
  function refresh() {
    return fetch(window.location.pathname, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshPanel = doc.querySelector('[data-drawer="cart"] .drawer__panel');
        var livePanel = document.querySelector('[data-drawer="cart"] .drawer__panel');
        if (freshPanel && livePanel) livePanel.innerHTML = freshPanel.innerHTML;

        var freshDot = doc.querySelector('[data-cart-dot]');
        var liveDot = document.querySelector('[data-cart-dot]');
        if (freshDot && liveDot) {
          liveDot.className = freshDot.className;
          liveDot.innerHTML = freshDot.innerHTML;
        }

        // Counts that sit outside the cart panel, such as the search bar's.
        var freshCounts = doc.querySelectorAll('[data-cart-bar-count]');
        var liveCounts = document.querySelectorAll('[data-cart-bar-count]');
        for (var i = 0; i < liveCounts.length && i < freshCounts.length; i++) {
          liveCounts[i].textContent = freshCounts[i].textContent;
        }
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var trigger = event.target.closest('[data-drawer-open]');
    if (trigger) {
      var drawer = panelFor(trigger.getAttribute('data-drawer-open'));
      if (drawer) {
        event.preventDefault();
        open(drawer);
      }
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      closeAll();
      return;
    }

    // Quantity steppers and the remove link inside the drawer: keep the panel
    // open instead of navigating to the cart page.
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(change.getAttribute('data-line')),
          quantity: Number(change.getAttribute('data-quantity'))
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('change failed');
          return refresh();
        })
        .catch(function () {
          // Fall back to the plain link so the change is never lost.
          window.location.href = change.getAttribute('href');
        });
    }
  });

  /*
   * Add to cart without leaving the page: post to the cart API, refresh the
   * panel, then slide it open. Any failure falls through to a normal form
   * submit so the product still reaches the cart.
   */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('[data-cart-add]')) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');

    var release = function () {
      if (button) button.removeAttribute('aria-busy');
    };

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return refresh();
      })
      .then(function () {
        release();
        open(panelFor('cart'));
      })
      .catch(function () {
        release();
        form.removeAttribute('data-cart-add');
        form.submit();
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
